import { useEffect, useState } from "react";
import "./createProductComponent.css";
import { create_product_restaurant,listProductCategories } from "../../services/products";
import {
  Button,
  ConfigProvider,
  Form,
  Input,
  InputNumber,
  Upload,
  notification,
  Select,
  Checkbox,
} from "antd";
import {
  UploadOutlined,
} from "@ant-design/icons";
import secureLocalStorage from "react-secure-storage";
import server from "../../config/server";
export default function CreateProductComponent() {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const [categories, setCategories] = useState([]);
  const [fileList, setFileList] = useState([]);


  const openNotificationSuccess = (placement, values) => {
    api.success({
      message: `Operação concluída com sucesso!`,
      description: `${values.name} foi criado com sucesso`,
      placement,
      duration: 3.5,
      onClose: () => {
        console.log("closed notification");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      },
    });
  };
  const openNotificationError = (placement) => {
    api.error({
      message: `Operação fracassada`,
      description: `Por favor, verifique as informações inseridas`,
      placement,
      duration: 3,
      onClose: () => {
        console.log("closed notification");
      },
    });
  };
  const { Option } = Select;
  const stylesInput = {
    borderColor: "#6A2A40",
  };
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await listProductCategories({});
        setCategories(response.items);
      } catch (error) {
        console.error("Erro ao buscar categorias de produtos:", error);
      }
    };
  
    fetchCategories();
  }, []);
  
  const onFinish = (values) => {
    const user_id = secureLocalStorage.getItem("user_id");
    
    const productData = {
      collibri_id: values.code,
      collibri_status: 1,
      name: values.name,
      description: values.description,
      food_region: values.food_region || "",
      pax: values.pax || 0,
      product_type: values.product_type,
      category: values.category,
      is_enabled: true,
      combo_flexible: values.combo_flexible || false,
      picture: values.picture,
      min_additional: values.min_additional || 0,
      max_additional: values.max_additional || 0,
      min_complement: values.min_complement || 0,
      max_complement: values.max_complement || 0,
      created_by: user_id,
    };

    create_product_restaurant({ product: productData })
      .then((response) => {
        form.resetFields();
        openNotificationSuccess("top", values);
      })
      .catch((error) => {
        console.error(error);
        openNotificationError("top");
      });
  };

  const onFinishFailed = (errorInfo) => {
    openNotificationError("top");
  };

  return (
    <>
      {contextHolder}
      <div className="create_product_container">
        <Form.Provider>
          <Form
            name="basic"
            onFinish={onFinish}
            form={form}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              name="picture"
              label="Imagem do Produto"
              rules={[
                {
                  required: false,
                  message: "Por favor, insira uma imagem",
                },
              ]}
            >
              <Upload
                listType="picture-card"
                maxCount={1}
                action={server + "/upload_files/upload"}
                headers={{
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                }}
                onChange={(info) => {
                  setFileList(info.fileList);
                  if (info.file.status === "done") {
                    const response = info.file.response;
                    const imageUrl = response?.path || response?.data?.path;

                    if (imageUrl) {
                      form.setFieldsValue({ picture: imageUrl });
                    } else {
                      console.error('Erro ao obter a URL da imagem enviada');
                    }
                  } else if (info.file.status === 'error') {
                    console.error('Erro no upload da imagem:', info.file.error);
                    api.error({
                      message: 'Erro no upload',
                      description: 'Não foi possível fazer o upload da imagem.',
                    });
                  }
                }}
                fileList={fileList}
              >
                {fileList.length >= 1 ? null : (
                  <div>
                    <Button icon={<UploadOutlined />}>Clique para enviar</Button>
                  </div>
                )}
              </Upload>
            </Form.Item>
            <Form.Item
              label="Nome"
              name="name"
              rules={[{ required: true, message: "Insira o nome do produto" }]}
            >
              <Input style={stylesInput} />
            </Form.Item>

            <Form.Item
              label="Descrição"
              name="description"
              rules={[
                { required: true, message: "Insira a descrição do produto" },
              ]}
            >
              <Input.TextArea style={stylesInput} />
            </Form.Item>
            <Form.Item
            label="Categoria"
            name="category"
            rules={[
              {
                required: true,
                message: "Selecione a categoria",
              },
            ]}
          >
            <Select
              style={stylesInput}
              placeholder="Selecione uma categoria"
              loading={categories.length === 0}
            >
              {categories.map((category) => (
                <Option key={category.id} value={category.id}>
                  {category.name}
                </Option>
              ))}
            </Select>
          </Form.Item>


            <Form.Item
              label="Código Colibri"
              name="code"
              rules={[
                {
                  required: true,
                  message: "Insira o código Colibri do produto",
                },
              ]}
            >
              <Input style={stylesInput} />
            </Form.Item>
            {/* Campos adicionais */}
            <Form.Item
              label="Tipo de Produto"
              name="product_type"
              rules={[
                { required: true, message: "Selecione o tipo de produto" },
              ]}
            >
              <Select style={stylesInput} placeholder="Selecione o tipo de produto">
                <Option value="regular">Produto</Option>
                <Option value="additional">Adicional</Option>
                <Option value="complement">Complemento</Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="PAX"
              name="pax"
              rules={[
                { required: true, message: "Informe o número de pessoas" },
              ]}
            >
              <InputNumber style={stylesInput} min={1} />
            </Form.Item>
            <Form.Item
              label="Combo Flexível"
              name="combo_flexible"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
            <Form.Item
              label="Região da Comida"
              name="food_region"
            >
              <Input style={stylesInput} />
            </Form.Item>
            <Form.Item
              label="Min Adicionais"
              name="min_additional"
            >
              <InputNumber style={stylesInput} min={0} />
            </Form.Item>
            <Form.Item
              label="Max Adicionais"
              name="max_additional"
            >
              <InputNumber style={stylesInput} min={0} />
            </Form.Item>
            <Form.Item
              label="Min Complementos"
              name="min_complement"
            >
              <InputNumber style={stylesInput} min={0} />
            </Form.Item>
            <Form.Item
              label="Max Complementos"
              name="max_complement"
            >
              <InputNumber style={stylesInput} min={0} />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8 }}>
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: "#6A2A40",
                    fontSize: 18,
                    fontSizeSM: 20,
                    borderRadius: 20,
                    paddingContentHorizontal: 70,
                  },
                }}
              >
                <Button type="primary" htmlType="submit">
                  Criar Produto
                </Button>
              </ConfigProvider>
            </Form.Item>
          </Form>
        </Form.Provider>
      </div>
    </>
  );
}
